import "core-js/modules/web.dom-collections.iterator.js";
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-89fac7a4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "go-top-pc"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    id: "gotop",
    class: _normalizeClass({
      'show': $setup.windowTop > 100,
      'goto-fifa': $setup.store.state.common.showFifaFlag
    }),
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.backToTop && $setup.backToTop(...args))
  }, "返回顶部", 2)]);
}